import { SystemEvent, SystemSlotEvent } from '@mbrtargeting/metatag-shared-types';

declare const window: Window & {
    yieldlove_ab?: {
        yieldlove_version: string;
        po: 'optimized_price' | 'default'
    },
    LUX?: {
        addData?: (key: string, value: string) => void;
    }
};

export class SpeedCurve {
    constructor() {
        /**
         * Direct Rendering analytics
         * some local.js are using their own implementation, might lead to multiple counts in SpeedCurve, remove those on MT2 launch
         * SpeedCurve LUX API might not be present on most sites, so check thoroughly before calling any functions
         */

        const win = window;

        // https://stroeerdigitalgroup.atlassian.net/browse/TICKET-31880
        win.addEventListener(SystemEvent.SDG_YIELDLOVE_AUCTION_DONE, () => {
            const po = win.yieldlove_ab?.po;
            if (po === 'optimized_price') {
                win.LUX?.addData?.('DRSetup', 'OptimizedSetup');
            } else if (po === 'default') {
                win.LUX?.addData?.('DRSetup', 'DefaultSetup');
            }
        });

        // https://stroeerdigitalgroup.atlassian.net/browse/TICKET-31215
        win.addEventListener(SystemSlotEvent.SDG_SLOT_DIRECT_RENDERING, ({ detail }) => {
            win.LUX?.addData?.('DirectRendering', 'Yes');
            win.LUX?.addData?.(`DirectRendering_${detail.slot}`, 'Yes');
        });
        win.addEventListener(SystemSlotEvent.SDG_SLOT_AD_SERVER_RENDERING, ({ detail }) => {
            win.LUX?.addData?.('DirectRendering', 'No');
            win.LUX?.addData?.(`DirectRendering_${detail.slot}`, 'No');
        });
    }
}
